
var reviewFrame = function(global) {
    var time_string = '';
    if (typeof global.elapsed_time !== 'undefined') {
        var timeFormat = '%d:%02d:%02d';
        var hours = Math.floor(global.elapsed_time/3600);
        var minutes = Math.floor((global.elapsed_time - ( hours * 3600 )) / 60);
        var seconds = global.elapsed_time - ( hours * 3600 ) - ( minutes * 60 );
        time_string = sprintf(timeFormat, hours, minutes, seconds);
    }


    var review_frame = '<div class="examReview">' +
        '<div class="row">' +
            '<div class="col-lg-12 col-md-12">' +
                '<div class="col-lg-8 col-md-8">' +
                    '<div class="all-box result-box cf"><h3>All</h3>' +
                        '<div class="col-lg-6 col-md-6">' +
                            '<canvas width="300" height="300"></canvas>' +
                        '</div>'+
                        '<div class="col-lg-6 col-md-6">' +
                            '<h4>'+global.name+'</h4>';
                            if (time_string.length > 0  ) {
                                review_frame += 'Time: '+ time_string + '<br/>';
                            }
                            review_frame += '<ul class="legend">' +
                            '<li>Score: '+ Math.floor( global.all.correct / global.all.answers.length * 100).toString() +'% </li>' +
                            '<li class="correct">Correct: '+global.all.correct+'</li>' +
                            '<li class="incorrect">Incorrect: '+global.all.incorrect+'</li>' +
                            '<li class="skipped">Skipped: '+global.all.skipped+'</li>' +
                            '<li class="unseen">Unseen: '+global.all.unseen+'</li>' +
                            '</ul>' +
                            '<a class="all-detail" title="all">Click here to review your answers</a>'+
                        '</div>'+
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';
    review_frame += '</div>';
    var review = $.parseHTML(review_frame);

    return review;
}

module.exports = reviewFrame;


//////////////////
// WEBPACK FOOTER
// ./src/review_frame.js
// module id = 235
// module chunks = 0